// components/ConfirmActionModal.jsx
import React from "react";

const ConfirmActionModal = ({ visible, message, onConfirm, onCancel, children }) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          maxWidth: "400px",
          textAlign: "center",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)"
        }}
      >
        <p>{message}</p>
        {children}
        <button
          onClick={onConfirm}
          style={{ marginRight: "15px", padding: "10px 15px", width: "auto" ,
            backgroundColor: "#07b1b0",color:"#fff",border:"none",borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          OK
        </button>
        <button
          onClick={onCancel}
          style={{
            padding: "10px 15px",
            width: "auto",
            backgroundColor: "#fff",
            border:"1px solid #07b1b0",
            color:"#07b1b0",borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ConfirmActionModal;
